import angular from 'angular';

import routeProviderConfig from './configs/routeProvider.config';

import media from './components/media/media.component';

/**
 * @ngdoc overview
 * @name media
 * @description
 * This module handles everything for the Media section.
 */
const mediaModule = angular.module('media', [])
.config(routeProviderConfig)
.component('media', media);
export default mediaModule.name;



// WEBPACK FOOTER //
// ./src/frontend/modules/media/index.js